<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="الإهداء">
<h1><span dir="rtl">الإهداء</span></h1>
<p><span dir="rtl">إلى تلك العصافير الصغيرة التي أخذَتها وسائل عديدة..</span></p>
<p><span dir="rtl">وأسرفَتِ الكثير مِن وقتها عن الغوص في بحر القراءة..</span></p>
<p><span dir="rtl">أن يعودوا للكتاب؛ فهو الكنز الحقيقي.</span></p>
<p><span dir="rtl">وإلى المُبحِرين في عالم العلم والمعرفة.</span></p>
<p><span dir="rtl">إلى كلِّ قارئ.</span></p>
<p><span dir="rtl"><br/>
</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?0f2a9136